import { useDigest } from '../lib/useDigest';

// Each node is a digest of its section heading, in the same voice as the state-history motif.
export const SectionNode = ({ id, heading }) => {
  const digest = useDigest(heading);
  const short = digest ? `${digest.slice(0, 4)}\u200A${digest.slice(4, 8)}` : '····\u200A····';
  return (
    <span className="section-node mono" title={digest ? `sha256: ${digest}` : undefined} data-testid={`${id}-section-node`}>
      <span className="section-node-junction" aria-hidden="true" />
      <span className="section-node-text">
        <code className="section-node-digest" aria-label={digest ? `Heading digest ${digest.slice(0, 8)}` : 'Computing heading digest'} data-testid={`${id}-section-digest`}>{short}</code>
        <span className="section-node-kind" aria-hidden="true">sha256</span>
      </span>
    </span>
  );
};
